import { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from 'axios';
import { MagnifyingGlass } from 'react-loader-spinner';
const {baseUrl} = require('../baseUrl')

const Testimonials = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [testimonials,setTestimonials] = useState([])
    const [loading,setLoading] =useState(false)

    const getTestimonials = async () =>{
        setLoading(true)
        try{
            const res=await axios.get(`${baseUrl}/testimonial/web`)
            setTestimonials(res.data.testimonials)

        }catch(err){
            console.log(err)
        }
        finally{
            setLoading(false)
        }

    }

    useEffect(()=>{
        getTestimonials()
    },[])

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        cssEase: "ease-in-out",
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    return (
        <section className="testimonial section-padding">
            <div className="container">
                <div className="row justify-content-center mb-4">
                    <div className="col-lg-6 text-center">
                        <span className="subheading">Testimonials</span>
                        <h3>Have a look at what our Students says.</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {
                            loading &&
                            <div className='d-flex justify-content-center'>
                                <MagnifyingGlass
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="magnifying-glass-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="magnifying-glass-wrapper"
                                    glassColor="#c0efff"
                                    color="#8000df"
                                />
                            </div>
                        }
                        {
                            !loading&&testimonials.length<1&&
                            <h4 className='text-center'>Coming Soon...</h4>
                        }
                        {
                            !loading && testimonials.length > 0 &&
                            <Slider {...settings}>
                                {testimonials.map((item, index) => {
                                    const isActive = index === currentSlide;
                                    return (
                                        <div key={index} className={`review-item p-3 ${isActive ? 'active-slide' : ''}`}>
                                            <div className="client-info">
                                                <p>{item.comment}</p>
                                                <div className="rating">
                                                    {[...Array(item.rating)].map((_, i) => (
                                                        <i key={i} className="fa fa-star ms-1"></i>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="client-desc gap-4">
                                                <div className="client-img me-3">
                                                    <img src={`${baseUrl}${item.studentImage}`} alt={item.studentName} />
                                                </div>
                                                <div className="client-text">
                                                    <h4>{item.studentName}</h4>
                                                    <span className="designation">{item.className}</span>
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-center'>
                                                <a className='text-center' target='_blank' href={item.ytlink}>watch on youtube</a>
                                            </div>
                                        </div>
                                    );
                                })}
                            </Slider>
                        }
                    </div>
                </div>
            </div>
            <style jsx="true">{`
                .review-item {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    opacity: 0.7;
                }
                .review-item.active-slide {
                    background: #222;
                    border: 1px solid #222;
                    border-top: 3px solid #FF1949;
                    transform: scale(1.05);
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                    opacity: 1;
                    background-color: #fff;
                    border-radius: 10px;
                }
                    .review-item.active-slide client-info{
                    background:#222
                    }
            `}</style>
        </section>
    );
};

export default Testimonials;
